import { render, staticRenderFns } from "./EditingLessonFolderModal.vue?vue&type=template&id=5ff333a1&scoped=true&"
import script from "./EditingLessonFolderModal.vue?vue&type=script&lang=ts&"
export * from "./EditingLessonFolderModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditingLessonFolderModal.vue?vue&type=style&index=0&id=5ff333a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff333a1",
  null
  
)

export default component.exports